<template>
  <div class="block block-cust">
    <div class="container">
      <div class="title title-cust">吉智实现合同全生命周期管理</div>
      <div class="entitle entitle-cust">
        Jizhi contract life cycle management
      </div>
      <div class="wrap-img">
        <img :src="p11" class="img-responsive" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import p11 from "@/assets/images/home/p11.png";
export default {
  data() {
    return {
      p11,
    };
  },
};
</script>

<style scoped>
.block-cust {
  background-color: #f2f6fa;
}
.title-cust {
  color: #3975ea;
}
.entitle-cust {
  color: #b3b3b3;
}
.wrap-img {
  margin-top: 60px;
}
</style>